import { AssignInvoiceData } from "./types";

export const assignInvoiceInitialValues: AssignInvoiceData = {
  invoice_id: "",
  property_id: "",
};
